module.exports = __webpack_public_path__ + "static/media/suite.e2ac99c1.jpg";